import { gql } from '@apollo/client'

const imDfmModalHeaderQuery = gql`
    query imDfmModalHeaderQuery($id: UUID!) {
        quoteModelRevision(id: $id) {
            id
            fileName
            partRevision {
                id
            }
            version
            quoteModel {
                selectedQuoteModelRevision {
                    version
                    id
                }
                quote {
                    id
                    user {
                        id
                    }
                }
            }
            dfmFeedback {
                id
            }
        }
    }
`

export default imDfmModalHeaderQuery
